import { render, staticRenderFns } from "./tourist-chart.vue?vue&type=template&id=2e43f778"
import script from "./tourist-chart.vue?vue&type=script&lang=js"
export * from "./tourist-chart.vue?vue&type=script&lang=js"
import style0 from "./tourist-chart.vue?vue&type=style&index=0&id=2e43f778&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports